@switch (linkType()) {
  @case ('internal') {
    <a
      wlTrackLink
      [trackLinkInfo]="{ type: 'navigation', field: linkTitle() }"
      [routerLink]="[linkUrl()]"
      [ngClass]="themeFormatted()"
      [class.navigation-link--fill]="fullWidth()"
      [class.navigation-link--active]="active()"
      (click)="clicked.emit()"
      >{{ linkTitle() }}</a
    >
  }
  @case ('external') {
    <a
      wlTrackLink
      [trackLinkInfo]="{ type: 'navigation', field: linkTitle() }"
      [href]="linkUrl()"
      [ngClass]="themeFormatted()"
      [class.navigation-link--fill]="fullWidth()"
      [class.navigation-link--active]="active()"
      (click)="clicked.emit()"
      >{{ linkTitle() }}</a
    >
  }
}
